module.exports = __webpack_public_path__ + "img/antes_despues_302.42938cf9.png";